import React from "react"
import { makeStyles } from "@material-ui/core";
import PropTypes from "prop-types";
import SwitcherComponent from "./SwitcherComponent";

const useStyles = makeStyles((theme) => ({
	switchesHr: {
		width: '100%',
		marginTop: theme.spacing(2),
		marginBottom: theme.spacing(2),
		border: 'none',
		height: 1,
		background: theme.palette.gray.light
	}
}));

const CookieSwitcherComponent = ({ title, desc, active, disabled, hiddenHr, handleChange = () => {}}) => {
	const classes = useStyles();

	return (
	<>
			<SwitcherComponent
				active={active}
				disabled={disabled}
				title={title}
				desc={desc}
				handleChange={handleChange}
			/>
			{!hiddenHr ? <hr className={classes.switchesHr} /> : null}
			</>
	);
};

CookieSwitcherComponent.propTypes = {
	 name: PropTypes.string,
};
export default React.memo(CookieSwitcherComponent);